export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/generic.9e49977.svg";